const foldSearchText = (text: string): string =>
  text.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase();

export const normalizeSearchText = (text: string): string => foldSearchText(text).trim();

/** Match folded text while retaining UTF-16 offsets into the original spelling. */
export function searchMatchRanges(text: string, search: string): { start: number; end: number }[] {
  const query = normalizeSearchText(search);
  if (!query) return [];
  const folded = foldSearchText(text);
  let offset = 0;
  const positions: { start: number; end: number }[] = [];
  for (const character of text) {
    const start = offset;
    offset += character.length;
    const fragment = foldSearchText(character);
    const last = positions.at(-1);
    if (!fragment && last) last.end = offset;
    for (let index = 0; index < fragment.length; index += 1) {
      positions.push({ start, end: offset });
    }
  }
  const ranges: { start: number; end: number }[] = [];
  for (
    let index = folded.indexOf(query);
    index !== -1;
    index = folded.indexOf(query, index + query.length)
  ) {
    const first = positions[index];
    const last = positions[index + query.length - 1];
    if (!first || !last) continue;
    const start = first.start;
    const end = last.end;
    const previous = ranges[ranges.length - 1];
    if (previous && start <= previous.end) previous.end = Math.max(previous.end, end);
    else ranges.push({ start, end });
  }
  return ranges;
}
